import { defineMessages } from 'react-intl-next';

export default defineMessages({
	sortAscending: {
		id: 'automation-table.sort.ascending.non-final',
		defaultMessage: 'Sort ascending',
		description: 'Label for ascending sort button',
	},
	sortDescending: {
		id: 'automation-table.sort.descending.non-final',
		defaultMessage: 'Sort descending',
		description: 'Label for descending sort button',
	},
});
